<template>
    <!--视频详情页-->
    <div class="container">
        <videoplayer :imgSrc="cover,charge" @tobuy="toBuyAll"></videoplayer>
        <div style="clear: both"></div>
        <div class="info">
            <p>{{videoListname}}</p>
            <del class="oldmoney">
                <span>¥{{old_price}}</span>
                <b>{{old_integral_price}}积分兑换</b>
            </del>
            <div class="xinmoney">
                <span>会员价专项：</span>
                <b>¥{{price}}/{{integral_price}}积分</b>
            </div>
            <div class="videotime">
                <i>上传时间：{{publish_date}}</i>
                <em>课时：{{classHour}}课时</em>
            </div>
        </div>
        <!-- <switches></switches> -->
        <div class="tabs" v-suctiontop>
           <div @click="toggleTab(videopic,'kecheng')" :class="{ active: (active === 'kecheng') }"><a href="javascript:;">课程介绍</a></div>
           <div @click="toggleTab(videolist,'mulu')" :class="{ active: (active === 'mulu') }"><a href="javascript:;">课程目录</a></div>
           <div @click="toggleTab(videoteacher,'jiangshi')" :class="{ active: (active === 'jiangshi') }"><a href="javascript:;">讲师介绍</a></div>
        </div>
        <!--tab 内容框-->
        <div>
            <div v-show="currentTab === 'videolist'">
                <videolist ref="usernameInput" keep-alive v-for="(item,i) in curriculum_s"  :key="i" :item="item" @setChapterId="setChapterId" @tobuy="toBuy" :parentCon="{videoListname:videoListname,cover:cover,price:price,integral_price:integral_price,bookId:bookId}"></videolist>
            </div>
            <!--tab 内容框-->
            <div v-show="currentTab === 'videopic'">
                <videopic></videopic>
            </div>
            <div v-show="currentTab === 'videoteacher'">
            <videoteacher></videoteacher>
        </div>
        </div>
        <!-- 会员价购买弹出框 -->
        <payPop v-show="popShow" @offPopchild="childpopoff" @offPopchild1="childpopoff1" :bookOrjie="bookOrjie" :audiopay="audioSum"></payPop>
        <!-- <payWays v-show="payWayshow" @offPayWay="offPayWay" :popways="{cover:cover,title:videoListname,price:price,jifen:integral_price}"></payWays> -->
        <payWays v-show="payWayshow" @offPayWay="offPayWay" :popways="bookOrjie" @h5paycallback="h5paycallback"></payWays>
        <!-- <videopic></videopic>
        <videoteacher></videoteacher> -->
    </div>
</template>
<script>
import videolist from "../components/bookvideo/videolist.vue";
import videopic from "../components/bookvideo/videopic.vue";
import videoteacher from "../components/bookvideo/videoteacher.vue";
import axios from "axios";
import qs from "qs";
import moment from "moment/moment.js";
import payPop from "../components/globe/payPop.vue";
import payWays from "../components/globe/payWays.vue";
import common from "../common.js";
import videoplayer from "../components/bookvideo/videoplayer.vue";
import { MessageBox } from "mint-ui";
function setChapterId(id) {
  this.chapterId = id;
}
//渲染本书所有章的信息
function getVideoList(vue) {
  let _this = vue;
  axios
    .post(
      "/wap/CurriHandle/curriList",//获取章列表接口
      qs.stringify({
        bookId: _this.bookId
      })
    )
    .then(function (res) {
        console.log(res);
      _this.goodData = res.data.data;//res 是整本书的信息
      _this.bookId = res.data.data.id;
      _this.videoListname = res.data.data.name;
      _this.old_price = res.data.data.old_price;
      _this.old_integral_price = res.data.data.old_integral_price;
      _this.price = res.data.data.price;
      _this.charge = Number(res.data.data.charge);
      //获取本书下的所有章
      _this.curriculum_s = res.data.data.curriculum_s;
      _this.integral_price = res.data.data.integral_price;
      _this.classHour = res.data.data.classHour;
      _this.cover = res.data.data.cover;
      _this.publish_date = moment(
        res.data.data.curriculum_s[0].publish_date
      ).format("YYYY.MM.DD");
    })
    ["catch"](function (error) {
      console.log(error);
    });
}
export default {
  name: "bookvideo",
  data() {
    return {
      chapterId: "",
      videolist: "videolist",
      videopic: "videopic",
      videoteacher: "videoteacher",
      currentTab: "videolist", //currentTab用于标识当前触发的子组件
      num: "videolist",
      active: "mulu",
      videoListname: "",
      old_price: "",
      old_integral_price: "",
      price: "",
      integral_price: "",
      classHour: "",
      publish_date: "",
      curriculum_s: "",//所有章
      cover: "",
      popShow: false, //整书购买/按节购买的弹框
      payWayshow: false, //微信支付，积分支付弹框的显示隐藏
      //支付方式：整书购买/按节购买
      bookOrjie: [
        {
          name: "会员价购买",
          price: "1",
          jifen: "2"
        },
        {
          name: "购买一节",
          price: "",
          jifen: ""
        }
      ],
      audioSum: "videoSum", //父级传来判断是视频还是听书
      bookId: this.$route.params.id || common.getUrlKey('id'),
      charge: '',
      wxpayprop: ''//微信内支付payways组件传过来的数据
    };
  },
  created() {
    getVideoList(this);
    //初始化视频章节的选中样式
    this.$store.state.listShow = false;
    this.$store.state.jieId = false;
      axios
          .post(
              "/wap/CurriHandle/getVideo",
              qs.stringify({
                  videoId: '738',
                  bookId: this.$route.params.id || common.getUrlKey('id')
              })
          )
          .then(data => {
              console.log(data);
          })
          ["catch"](error => {
              console.log(error);
          });
  },
    mounted() {
        //微信内支付回调显示
        // 1代表正在支付中
        if (localStorage.getItem("IsPayStatuCode") === "1") {
            this.payWayshow = false;//关闭支付方式弹框
            var state = common.getUrlKey('state');
            var code = common.getUrlKey('code');
            this.$WxJsapiPay("/wap/WxpayFor/sendCode", {state: state, code: code}, (res)=>{
                localStorage.removeItem('IsPayStatuCode');  //如果支付成功，清空状态
                var _this = this;
                MessageBox.confirm('是否已支付完成？',{ title:"提示", confirmButtonClass:'confirmButton', cancelButtonClass:'cancelButton' }).then((data) => {
                    if (data == 'confirm') {
                        var PayParams = JSON.parse(localStorage.getItem("PayParams"));
                        _this.wxInpay(PayParams);
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },function(){
                this.offPayWay();
                this.Toast({ message: res.msg, position: "center", duration: 2000 });
            });
        }
        //微信外 浏览器支付
        this.h5paycallback();
        // if(localStorage.getItem("IsPayStatuCodeByH5") === "1"){
        //     this.payWayshow = false;//关闭支付方式弹框
        //     //localStorage.removeItem('IsPayStatuCodeByH5');  //清空状态
        //     var _this = this;
        //     MessageBox.confirm('是否已支付完成？',{ title:"提示", confirmButtonClass:'confirmButton', cancelButtonClass:'cancelButton' }).then((data) => {
        //         if (data == 'confirm') {
        //             localStorage.removeItem('IsPayStatuCodeByH5');  //清空状态
        //             var PayParams = JSON.parse(localStorage.getItem("PayParamsByH5"));
        //             _this.wxInpay(PayParams);
        //         }
        //
        //     }).catch((err) => {
        //         if (err == 'cancel') {     //取消的回调
        //             localStorage.removeItem('IsPayStatuCodeByH5');  //清空状态
        //         }
        //         console.log(err);
        //     });
        // }
    },
  components: {
    videolist,
    videopic,
    videoteacher,
    payPop,
    payWays,
    videoplayer
  },
  methods: {
    setChapterId,
    toggleTab: function (tab, str) {
      this.currentTab = tab; //tab为当前触发标签页的组件名
      this.active = str;
    },
    toBuy: function (jieobj) {
      this.popShow = true;
      this.bookOrjie = jieobj;
    },
    //视频遮罩  点击会员购买
    toBuyAll: function () {
       //判断登录
        axios
            .post(
                "/wap/userHandle/getUserInfo",
            )
            .then(data => {
                var data = data.data.data;
                if (data === 'notLogin') {
                    MessageBox.confirm('立即登录', {
                        title: "提示",
                        confirmButtonClass: 'confirmButton',
                        cancelButtonClass: 'cancelButton',
                    })
                        .then(() => {
                            this.$router.push({
                                path: "/login",
                                query: {redirect: location.hostname}
                            });
                        })
                        ["catch"](() => {
                            return false;
                        });
                } else {
                    this.popShow = true;
                    this.bookOrjie = [
                        {
                            popname: "会员价购买",
                            price: this.price,
                            jifen: this.integral_price,
                            cover: this.cover,
                            name: this.videoListname,
                            bookId: {
                                bookId: this.goodData.id
                            },
                            axiospath: "/wap/IntegralHandle/getAllVideo", //默认积分支付
                            axiospathwx: "/wap/WxpayFor/getAllVideo" //微信支付
                        }
                    ];
                }
            })
    },
    childpopoff: function () {
      this.popShow = false;
      //common.move();
    },
    childpopoff1: function (obj) {
      this.popShow = false;
      this.bookOrjie = obj;
      this.payWayshow = true;
    },
    //监听子组件，支付成功，进行回调页面渲染
    offPayWay: function (videoObj) {
        this.payWayshow = false;//关闭支付方式弹框
        this.wxpayprop = videoObj;
        /**********************积分支付********************/
        //videoObj.videoId按节支付时才有值,整本书是videoObj.bookId
        //videoObj.data
        //积分支付整本书购买的回调页面展示
        if (videoObj && videoObj.bookId && videoObj.data) {
            this.charge = 2;
        }
        //按节支付 回调页面展示
        if (videoObj && this.chapterId !== "" && !videoObj.videoId) {
            let id = this.chapterId;
            let childernArr = this.$refs.usernameInput;
            for (let i = 0; i < childernArr.length; i++) {
                if (childernArr[i].chapterId === id) {
                    childernArr[i].setSectionList();
                }
            }
            return false;
        }
      //积分按节支付后的回调页面展示
      if (videoObj && this.chapterId !== "") {
        // videoObj.videoId = videoObj.videoId || true;
        let id = this.chapterId;
        let childernArr = this.$refs.usernameInput;
        console.log(childernArr);
        for (let i = 0; i < childernArr.length; i++) {
          if (childernArr[i].chapterId === id) {
            for (let s = 0; s < childernArr[i].SectionList.length; s++) {
              if (childernArr[i].SectionList[s].id === videoObj.videoId) {
                childernArr[i].SectionList[s].charge = videoObj.data.charge;
                childernArr[i].SectionList[s].file_path =
                  videoObj.data.file_path;
                videoObj.data.id = videoObj.data.videoId;
                this.$store.commit("videoPathChange", videoObj.data);
                this.$store.commit("videoPathsChange", true);//控制封面
                this.$store.commit("jieChoosed", childernArr[i].SectionList[s]);
              }
            }
          }
        }
      }
      /*****************************微信支付***********************************/
        //this.wxInpay(videoObj);
        //return false;

        //微信 按节支付 渲染回调页面
        // if (!videoObj.data) {
        //     let _this = this;
        //     setTimeout(function () {
        //         MessageBox.confirm('是否已支付完成？', {
        //             title: "提示",
        //             confirmButtonClass: 'confirmButton',
        //             cancelButtonClass: 'cancelButton',
        //
        //         })
        //             .then(() => {
        //                 //微信支付  请求回调接口
        //                 axios
        //                     .post(
        //                         "/wap/CurriHandle/getVideo",
        //                         qs.stringify({
        //                             videoId: videoObj.videoId,
        //                             bookId: _this.$route.params.id
        //                         })
        //                     )
        //                     .then(data => {
        //                         console.log(data);
        //                         var data = data.data.data;//charge,id,name...
        //                         videoObj.data = data;
        //                         if (videoObj.bookId && videoObj.data) {
        //                             _this.charge = 2;
        //                         }
        //                         //videoObj  data,ip,videoId
        //                         if (videoObj.data.charge == 2) {
        //                             if (videoObj.videoId) {
        //                                 let id = _this.chapterId;
        //                                 let childernArr = _this.$refs.usernameInput;
        //                                 for (let i = 0; i < childernArr.length; i++) {
        //                                     if (childernArr[i].chapterId === id) {
        //                                         for (let s = 0; s < childernArr[i].SectionList.length; s++) {
        //                                             if (childernArr[i].SectionList[s].id === videoObj.videoId) {
        //                                                 console.log(videoObj.data.charge);
        //                                                 childernArr[i].SectionList[s].charge = videoObj.data.charge;
        //                                                 console.log(videoObj.data);
        //                                                 console.log(videoObj);
        //                                                 childernArr[i].SectionList[s].file_path =
        //                                                     videoObj.data.file_path;
        //                                                 videoObj.data.id = videoObj.videoId;
        //                                                 _this.$store.commit("videoPathChange", videoObj.data);
        //                                                 _this.$store.commit("videoPathsChange", true);//控制封面
        //                                                 _this.$store.commit("jieChoosed", childernArr[i].SectionList[s]);
        //                                             }
        //                                         }
        //                                     }
        //                                 }
        //                             }
        //                         }
        //                     })
        //                     ["catch"](error => {
        //                     console.log(error);
        //                 });
        //             })
        //             ["catch"](() => {
        //             return false;
        //         });
        //     }, 1500);
        // }
    },
      //微信内支付成功回调
      wxInpay:function (videoObj) {
          axios
              .post(
                  "/wap/CurriHandle/getVideo",
                  qs.stringify({
                      videoId: videoObj.videoId,
                      bookId: this.$route.params.id
                  })
              )
              .then(data => {
                  console.log(data);
                  var data = data.data.data;//charge,id,name...
                  videoObj.data = data;
                  if (videoObj.bookId && videoObj.data) {
                      this.charge = 2;
                  }
                  //videoObj  data,ip,videoId
                  if (videoObj.data.charge == 2) {
                      if (videoObj.videoId) {
                          //let id = this.chapterId;//this.chapterId通过子组件emit获取
                          let id = localStorage.getItem('ChapterId');
                          let childernArr = this.$refs.usernameInput;
                          for (let i = 0; i < childernArr.length; i++) {
                              if (childernArr[i].chapterId == id) {
                                  this.$refs.usernameInput[i].getSectionList(id,videoObj.videoId);//章id  节id 传到子组件进行回调渲染
                                  // for (let s = 0; s < childernArr[i].SectionList.length; s++) {
                                  //     alert('aaaaaaaaaaaaa');
                                  //     alert(childernArr[i].SectionList[s].id);
                                  //     alert(videoObj.videoId);
                                  //     if (childernArr[i].SectionList[s].id == videoObj.videoId) {
                                  //         alert(369);
                                  //         console.log(videoObj.data.charge);
                                  //         childernArr[i].SectionList[s].charge = videoObj.data.charge;//修改状态付费———已付
                                  //         console.log(videoObj.data);
                                  //         console.log(videoObj);
                                  //         childernArr[i].SectionList[s].file_path =
                                  //             videoObj.data.file_path;
                                  //         videoObj.data.id = videoObj.videoId;
                                  //         alert(369999);
                                  //         this.$store.commit("videoPathChange", videoObj.data);
                                  //         this.$store.commit("videoPathsChange", true);//控制封面
                                  //         this.$store.commit("jieChoosed", childernArr[i].SectionList[s]);
                                  //     }else{
                                  //         alert(jjjjjjj);
                                  //     }
                                  // }
                              }
                          }
                      }
                  }
              })
              ["catch"](error => {
              alert(error);
              console.log(error);
          });
      },
      h5paycallback:function () {
          if(localStorage.getItem("IsPayStatuCodeByH5") === "1"){
              this.payWayshow = false;//关闭支付方式弹框
              var _this = this;
              MessageBox.confirm('是否已支付完成？',{ title:"提示", confirmButtonClass:'confirmButton', cancelButtonClass:'cancelButton' }).then((data) => {
                  if (data == 'confirm') {
                      localStorage.removeItem('IsPayStatuCodeByH5');  //清空状态
                      var PayParams = JSON.parse(localStorage.getItem("PayParamsByH5"));
                      _this.wxInpay(PayParams);
                  }

              }).catch((err) => {
                  if (err == 'cancel') {     //取消的回调
                      localStorage.removeItem('IsPayStatuCodeByH5');  //清空状态
                  }
              });
          };
      }
  },
  directives: {
    suctiontop: {
      inserted: function (el) {
        window.onscroll = function () {
          let top =
            document.documentElement.scrollTop || document.body.scrollTop;
          let oWidth =
            document.documentElement.clientWidth || document.body.clientWidth;
          let domHeight = (oWidth / 750) * 100 * 4.24 - 2;
          if (
            el.nextElementSibling.offsetTop - top <=
            domHeight + el.offsetHeight + 10
          ) {
            el.style = "position:fixed;top:" + domHeight + "px;z-index:1";
          } else {
            el.style = "";
          }
        };
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 424px;
}
.container /deep/ .player {
  position: fixed;
  top: 0;
  z-index: 1000;
}
.info {
  /*height: 300px;*/
  border-bottom: 20px solid #f6f7f8;
  p {
    font-size: 32px;
    color: #333;
    width: 84.27%;
    margin-left: 31px;
    margin-top: 41px;
  }
  .oldmoney {
      display: block;
    color: #999;
    margin-top: -40px;
    /*text-decoration-line: line-through;*/
    /*text-decoration: line-through;*/
    span {
      font-size: 30px;
      padding-left: 30px;
    }
    b {
      font-weight: normal;
      font-size: 22px;
      padding-left: 29px;
    }
  }

  .xinmoney {
    color: #ff8005;
    margin-top: -50px;
    span {
      font-size: 30px;
      padding-left: 30px;
    }
    b {
      font-weight: normal;
      font-size: 30px;
    }
  }
  .videotime {
    color: #999;
    font-size: 26px;
    i {
      padding-left: 30px;
    }
    em {
      padding-left: 29px;
    }
  }
}
.tabs {
  width: 100%;
  border-bottom: 1PX solid #e6e7e8;
  color: #999;
  background: #fff;
  overflow: hidden;
  div {
    float: left;
    width: 33.3%;
    font-size: 28px;
    text-align: center;
    line-height: 100px;
  }
  .active {
    border-bottom: 6px solid #ff8005;
    a {
      color: #333;
    }
  }
}
.square {
  color: #999;
  border-bottom: none;
}
</style>
